import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'
import ToggleSwitch from '../ToggleSwitch'

function AccordionItem({ id, title, isSwitchOn, children, arrowPosition, withSwitch, handleSwitchChange }) {
  const [isExpanded, setIsExpanded] = useState(false)
  const handleClick = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <React.Fragment>
      <button
        id={`${id}-header`}
        className={`${styles.accButton} ${arrowPosition === 'start' && styles.accButtonStart}`}
        aria-controls={`${id}-panel`}
        aria-expanded={isExpanded}
        onClick={handleClick}>
        {arrowPosition === 'start' && (
          <Icon
            name={isExpanded ? 'chevron-up' : 'chevron-down'}
            styleModifier={styles.accdnChevron}
            size='large'
            alt=''
          />
        )}
        <span className={styles.accdnHeading}>{title}</span>
        {arrowPosition === 'end' && (
          <Icon
            name={isExpanded ? 'chevron-up' : 'chevron-down'}
            styleModifier={styles.accdnChevron}
            size='large'
            alt=''
          />
        )}
        {withSwitch ? (
          typeof isSwitchOn === 'string' ? (
            <div className={styles.alwaysActive}>{isSwitchOn}</div>
          ) : (
            <div className={styles.switchContainer}>
              <ToggleSwitch
                isChecked={isSwitchOn == 1}
                height={16}
                onChange={() => handleSwitchChange(id, isSwitchOn == 1 ? 0 : 1)}
                stopPropagation={true}
              />
            </div>
          )
        ) : null}
      </button>

      <section
        className={isExpanded ? styles.showContent : styles.hideContent}
        id={`${id}-panel`}
        aria-labelledby={`${id}-header`}>
        {children}
      </section>
    </React.Fragment>
  )
}

export default function Accordion({
  data,
  className = '',
  arrowPosition = 'end',
  withSwitch = false,
  handleSwitchChange
}) {
  return (
    <ul className={`${styles.accdn} ${className}`}>
      {data &&
        data.length > 0 &&
        data.map((d, index) => (
          <li className={styles.accdnItem} key={index}>
            <AccordionItem
              id={d.id || `item${index}`}
              title={d.title}
              isSwitchOn={d.switch}
              arrowPosition={arrowPosition}
              withSwitch={withSwitch}
              handleSwitchChange={handleSwitchChange}>
              {typeof d.description === 'object' ? (
                <p className={styles.accdnContentWrapper}> {d.description}</p>
              ) : (
                <p className={styles.accdnContentWrapper} dangerouslySetInnerHTML={{ __html: d.description }} />
              )}
            </AccordionItem>
          </li>
        ))}
    </ul>
  )
}
Accordion.propTypes = {
  data: PropTypes.array
}

Accordion.defaultProps = {
  data: []
}
